import React from 'react';
// Replace this with the actual path to your centralized JPEG logo
import LogoImg from './logo22.jpeg'; 

const Footer = () => {
  return (
    <footer className="w-full bg-[#F9F6F0] text-neutral-800">
      
      

       

      

      {/* 4. Bottom Identity & Social Row */}
      <div className="py-8 px-6 md:px-12 max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between border-t border-neutral-200/50 gap-6">
        
        {/* Center alignment spacer placeholder to mirror structure exactly */}
        <div className="hidden sm:block w-24"></div>

        {/* Brand Main Logo Badge */}
        <div className="flex flex-col items-center space-y-2">
          <img 
            src={LogoImg} 
            alt="Tuljai Brand Logo" 
            className="w-16 h-16 object-cover rounded-full shadow-md border border-amber-800/10" 
          />
          <span className="text-[10px] tracking-widest font-serif font-light text-neutral-500 uppercase">
            TULJAI BOUTIQUE
          </span>
        </div>

        {/* Social Media Link Icons */}
        <div className="flex items-center space-x-4 text-neutral-600">
          <a href="https://www.instagram.com/tuljai_nauvari_boutique?igsh=M2p1aGk1ZHVxZnJv"   target="_blank"  className="hover:text-[#5c1d24] transition-colors" aria-label="Instagram">
           <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M7.75 2C4.574 2 2 4.574 2 7.75v8.5C2 19.426 4.574 22 7.75 22h8.5C19.426 22 22 19.426 22 16.25v-8.5C22 4.574 19.426 2 16.25 2h-8.5zm0 2h8.5A3.75 3.75 0 0 1 20 7.75v8.5A3.75 3.75 0 0 1 16.25 20h-8.5A3.75 3.75 0 0 1 4 16.25v-8.5A3.75 3.75 0 0 1 7.75 4zm8.9 1a.85.85 0 1 0 0 1.7.85.85 0 0 0 0-1.7zM12 6.5A5.5 5.5 0 1 0 17.5 12 5.506 5.506 0 0 0 12 6.5zm0 2A3.5 3.5 0 1 1 8.5 12 3.504 3.504 0 0 1 12 8.5z"/>
  </svg>
          </a>
          <a href="https://www.facebook.com/share/1cPXuHr9bN/"   target="_blank"  className="hover:text-[#5c1d24] transition-colors" aria-label="Facebook">
             <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M24 12.073C24 5.405 18.627 0 12 0S0 5.405 0 12.073c0 6.017 4.388 11.006 10.125 11.927v-8.437H7.078V12.07h3.047V9.413c0-3.007 1.792-4.669 4.533-4.669 1.313 0 2.686.235 2.686.235v2.953h-1.514c-1.492 0-1.956.93-1.956 1.884v2.254h3.328l-.532 3.493h-2.796V24C19.612 23.08 24 18.09 24 12.073z"/>
  </svg>
          </a>
          <a href="https://share.google/XqEr5NM7Wi8CwzCgW"   target="_blank"  className="hover:text-[#5c1d24] transition-colors" aria-label="Twitter / X">
           <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    width="24"
    height="24"
    fill="none"
  >
    <path
      fill="#4285F4"
      d="M42 20H24v8h10.3c-.9 4.2-4.5 8-10.3 8-6.2 0-11.3-5.1-11.3-11.3S17.8 13.4 24 13.4c2.8 0 5.4 1 7.4 2.8l5.7-5.7C33.5 7.3 29 5.5 24 5.5 13.8 5.5 5.5 13.8 5.5 24S13.8 42.5 24 42.5c10.5 0 17.5-7.4 17.5-17.8 0-1.2-.1-2.3-.3-3.4Z"
    />
    <path
      fill="#34A853"
      d="M6.8 14.7l6.6 4.8C15.2 16 19.2 13.4 24 13.4c2.8 0 5.4 1 7.4 2.8l5.7-5.7C33.5 7.3 29 5.5 24 5.5c-7.2 0-13.4 4.1-17.2 10.2Z"
    />
    <path
      fill="#FBBC05"
      d="M24 42.5c4.9 0 9.3-1.6 12.7-4.5l-5.9-4.8c-1.9 1.3-4.2 2-6.8 2-5.7 0-9.9-3.8-10.9-8.9l-6.5 5c3.7 7.2 10.8 11.2 17.4 11.2Z"
    />
    <path
      fill="#EA4335"
      d="M6.8 14.7A18.2 18.2 0 0 0 5.5 24c0 3.2.8 6.2 2.2 8.8l6.5-5A11.4 11.4 0 0 1 13.4 24c0-1.6.3-3.1.9-4.5l-6.6-4.8Z"
    />
  </svg>
          </a>
        </div>
      </div>

    </footer>
  );
};

export default Footer;